<template>
  <div class="card notifications-page">
    <div class="card-body">
      <div class="page-header mb-2">
        <h3 class="mb-25">
          Уведомления
        </h3>
        <p class="text-muted mb-0">
          Рассылка сообщений пользователям в личный кабинет, управление шаблонами и история отправок.
        </p>
      </div>

      <b-tabs
        v-model="activeTab"
        pills
        card
        :lazy="false"
        class="notifications-tabs"
        @input="onTabChange"
      >
        <b-tab title="Создать уведомление">
          <notification-create-tab
            ref="createTab"
            @open-history="openHistoryTab"
            @sent="onNotificationSent"
          />
        </b-tab>

        <b-tab title="Шаблоны">
          <notification-templates-tab
            ref="templatesTab"
            @use="onUseTemplate"
          />
        </b-tab>

        <b-tab title="История отправок">
          <notification-history-tab ref="historyTab" />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { BTab, BTabs } from 'bootstrap-vue'
import NotificationCreateTab from './NotificationCreateTab.vue'
import NotificationTemplatesTab from './NotificationTemplatesTab.vue'
import NotificationHistoryTab from './NotificationHistoryTab.vue'

export default {
  name: 'NotificationsPage',
  components: {
    BTab,
    BTabs,
    NotificationCreateTab,
    NotificationTemplatesTab,
    NotificationHistoryTab,
  },
  data() {
    return {
      activeTab: 0,
    }
  },
  methods: {
    onTabChange(tabIndex) {
      if (tabIndex === 0) {
        this.$refs.createTab?.loadTemplates?.()
      }
      if (tabIndex === 1) {
        this.$refs.templatesTab?.loadTemplates?.()
      }
      if (tabIndex === 2) {
        this.$refs.historyTab?.loadHistory?.()
      }
    },
    onUseTemplate(template) {
      this.activeTab = 0
      this.$nextTick(() => {
        this.$refs.createTab?.applyTemplateData?.(template)
      })
    },
    openHistoryTab() {
      this.activeTab = 2
      this.$nextTick(() => {
        this.$refs.historyTab?.loadHistory?.()
      })
    },
    onNotificationSent() {
      this.$refs.historyTab?.loadHistory?.()
    },
  },
}
</script>

<style lang="scss">
@import './_notifications.scss';
</style>
